/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_BudgetInputs */

const en_gc_editor_budget = /** @type {(inputs: Gc_Editor_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly budget`)
};

const zh_gc_editor_budget = /** @type {(inputs: Gc_Editor_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月度预算`)
};

/**
* | output |
* | --- |
* | "Monthly budget" |
*
* @param {Gc_Editor_BudgetInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_budget = /** @type {((inputs?: Gc_Editor_BudgetInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_BudgetInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_budget(inputs)
	return zh_gc_editor_budget(inputs)
});
export { gc_editor_budget as "gc.editor.budget" }